import template from './coworking-floor.jade';
import { CoworkingFloorCtrl } from './coworking-floor.controller';
import './coworking-floor.css';

export default angular.module('cian.addForm.coworkingFloor', []).directive('cianAfAboutObjectCoworkingFloor', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: CoworkingFloorCtrl,
  controllerAs: 'coworkingFloor',
  template,
})).name;
